<template>


  <transition name="animate-intro">

    <div class="splashAnimation">
      <div class="splashAnimation__wrapper">

        <div class="splashAnimation__background">
          <video loop
                 playsinline
                 autobuffer
                 muted
                 :poster="returnPath('assets/img/video-intro-background.jpg')"
                 class="fullscreen-bg__video">
            <source src="https://content.jwplatform.com/videos/9om61RZg-Mbv5hjNP.mp4" type="video/mp4">
          </video>
        </div>

        <div class="splashAnimation__content">
          <svg xmlns="http://www.w3.org/2000/svg" class="cubo" viewBox="0 0 40 45.3"><path class="st0" d="M20.4 22.3v20.4M37.9 11.9L20.4 22.3 2.6 11.9M2.6 12.1L20.5 1.7l17.5 10.4v20.2L20.4 42.7 2.6 32.3V12.1z"/><path class="st1" d="M3.9 31.5c0.3-0.1 16.5-9.2 16.5-9.2l16.5 9.2"/><line class="st1" x1="20.5" y1="1.7" x2="20.5" y2="20.8"/></svg>
          <h1>The Light Experience</h1>
          <transition name="slideFromBottom">
            <div class="splashAnimation__start" v-if="animationDone" @click="closeSplashScreen">
              {{startCta}}
              <div class="splashAnimation__start__icon">
                <icon-pointer></icon-pointer>
              </div>
            </div>
          </transition>

          <transition name="slideFromBottom">
            <div class="interface homepage">
              <div class="interface__language" @click.stop>
                <template  v-for="lang in languages">
                  <span v-if="isDefaultLang(lang.key)">{{lang.label}}</span>
                </template>
                

                <button @click="toggleBox">
                  <!-- <icon-world :class="{active: isLangBoxVisible}"></icon-world> -->
                  {{languagesDescription}}
                </button>
                <div class="interface__list" v-show="isLangBoxVisible">
                  <div class="interface__list__header">
                    <span>{{languagesHeader}}</span>
                  </div>
                  <div class="interface__list__options">
                    <div class="interface__box__header">
                      <span>{{languagesDescription}}:</span>
                    </div>
                    <div class="interface__box__list">
                      <div class="interface__box__lang" v-for="lang in languages">
                        <input type="radio" :checked="isDefaultLang(lang.key)" @change="changeSelectedLang(lang.key)"
                              name="lang" id="lang.key"/>
                        <label for="lang.key">{{lang.label}}</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            </transition>

        </div>
      </div>

      <div class="interface__logo">
        <a href="https://www.iguzzini.com" target="_blank" title="iGuzzini" @click="trackExternalLink">
          <img :src="returnPath('assets/img/shared/iguzzini-logo-red.png')" alt="iGuzzini"/>
        </a>
      </div>

    </div>


  </transition>
</template>

<script>
  import Pointer from './icons/Pointer';

  export default{
    props: ['isParentMounted'],
    data(){
      return {
        startCta: '',
        animationDone: false,
        isLangBoxVisible: false,
        languagesDescription: '',
        languages: [],
      }
    },
    created(){
      var vm = this;
      vm.languages = vm.$store.state.labels.interface.languagesList;
      document.querySelector('body').addEventListener('click', function (evt) {
        vm.isLangBoxVisible = false;
      });
    },
    computed: {
      getLabelLanguages(){
        this.languages = this.$store.state.labels.interface.languagesList;
      }
    },
    components: {
      'icon-pointer': Pointer
    },
    watch: {
      isParentMounted(){
        var vm = this;
        setTimeout(function () {
          vm.animationDone = true;
        }, 3000);
      }
    },
    methods: {
      returnPath(path){
        return ENV.assetsRoot + path;
      },
      closeSplashScreen(){
        document.querySelector('.splashAnimation__content').setAttribute('data-fade-out', 'true');
        this.$emit('intro-status-changed');
      },
      trackExternalLink(e) {
        var href = e.currentTarget.getAttribute('href');

        eventTracking.send({
          category: 'ExternalLink',
          value: 'Click',
          label: href
        });
      },
      isDefaultLang(lang){
        return lang == this.$route.params.lang;
      },
      changeSelectedLang(lang){
        var vm = this;
        this.$store.state.selectedLang = lang;
        this.isLangBoxVisible = !this.isLangBoxVisible;
        if (ENV.debugMode) {
          ENV.lang = lang;
          vm.areLabelsLoaded = false;
          var prev_labels_url = document.querySelector('#root').getAttribute('data-endpoint-labels');
          var str_length = prev_labels_url.length;
          var new_labels_url = prev_labels_url.substr(0, str_length - 7) + lang.toUpperCase() + prev_labels_url.substr(str_length - 5);
//          console.log(prev_labels_url);
//          console.log(new_labels_url);
          document.querySelector('#root').setAttribute('data-endpoint-labels', new_labels_url);
          vm.changeLangLabels();
        }
        else {
          window.location.href = vm.splitPath(vm.$route.path, lang);
        }
      },
      splitPath(path, currentLang){
        //Function to take current url and, based on route params, build the same path in a different lang
        //@path: {String}
        //  current url path
        //@currentLang: {String}
        //  string ID of chosen lang
        var splitPathArray = path.split('/');
        var newArray = [];
        var mainComponent;
        for (var i = 0; i < splitPathArray.length; i++) {
          var tempStr = splitPathArray[i];
          switch (i) {
            case 0:
            {
              newArray.push(tempStr);
              break;
            }
            case 1:
            {
              tempStr = currentLang;
              newArray.push(tempStr);
              break;
            }
            case 2:
            {
              newArray.push(tempStr);
              break;
            }
            case 3:
            {
              mainComponent = tempStr;
              if (mainComponent == 'visita-guidata' || mainComponent == 'virtual-tour' || mainComponent == 'guided-tour') {
                switch (currentLang) {
                  case 'en':
                  {
                    tempStr = 'guided-tour';
                    break;
                  }
                  case 'it':
                  {
                    tempStr = 'visita-guidata';
                    break;
                  }
                  default:
                  {
                    tempStr = 'guided-tour';
                    break;
                  }
                }
              }
              else if (mainComponent == 'interactive' ||
                mainComponent == 'interactive-3d-mode' ||
                mainComponent == 'modalita-3d-interattiva' ||
                mainComponent == 'modalità-3d-interattiva') {
                switch (currentLang) {
                  case 'en':
                  {
                    tempStr = 'interactive-3d-mode';
                    break;
                  }
                  case 'it':
                  {
                    tempStr = 'modalita-3d-interattiva';
                    break;
                  }
                  default:
                  {
                    tempStr = 'interactive-3d-mode';
                    break;
                  }
                }
              }
              newArray.push(tempStr);
              break;
            }
            case 4:
            {
              newArray.push(tempStr);
              break;
            }
            case 5:
            {
              newArray.push(tempStr);
              break;
            }
            default:
            {
              newArray.push(tempStr);
              break;
            }
          }
        }
        var resultPath = newArray.join('/');
        return resultPath;
      },
      routeRedirect(index){
        var vm = this;
        var lang = this.$route.params.lang;
        switch (index) {
          case 0:
          {
            vm.$store.state.sceneListing.forEach(function (currentScene) {
              if (vm.$route.params.scenedetail == currentScene.slag) {
                vm.$store.state.activeSlide = vm.$store.state.sceneListing.indexOf(currentScene);
              }
            });
            vm.$router.push('/' + lang);
            vm.$store.state.interface.isVisible = true;
            vm.$store.state.interface.breadcrumbsOnly = false;
            vm.$store.state.interface.isFooterVisible = true;
            break;
          }
          case 1:
          {
            vm.$router.push(vm.$route.path);
            break;
          }
          case 2:
          {
            vm.$router.push(vm.$route.path);
            break;
          }
          default:
          {
            vm.$router.push('/' + lang);
            vm.$store.state.interface.isVisible = true;
            vm.$store.state.interface.breadcrumbsOnly = false;
            vm.$store.state.interface.isFooterVisible = true;
            break;
          }
        }
        this.buildBreadcrumbs();
      },
      toggleBox(){
        this.isLangBoxVisible = !this.isLangBoxVisible;
      }
    },
    mounted(){
      var lang = this.$route.params;
      var vm = this;
      vm.startCta = vm.$store.state.labels.startApplication;
      setTimeout(function () {
        var video = document.querySelector('video.fullscreen-bg__video');
        video.addEventListener('click', function () {
          video.play();
        }, false);
        video.click();
        document.querySelector('.splashAnimation__content').setAttribute('data-animate', 'true');
      }, 500);
    },
    updated(){
      var vm = this;
      vm.languages = vm.$store.state.labels.interface.languagesList;
      vm.languagesHeader = vm.$store.state.labels.interface.languagesHeader;
      vm.languagesDescription = vm.$store.state.labels.interface.languagesDescription;
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/SplashAnimation.vue